<app-toaster class="toaster" [config]="toastService.toaster"></app-toaster>
<filter-pane [filterComponents]="filterComponents" [showFilter]="showFilters"
  (submit)="applyFilters($event)"></filter-pane>
<div>
  <mat-toolbar class="toolbar-border">
    {{ title }}
    <div class="pull-right is-flex" style="height: 35px;">
      <button mat-raised-button class="btn-primary" (click)="showFilters = !showFilters">Filters</button>
    </div>
  </mat-toolbar>
  <div class="approvals-table">
    <data-table [table]="table" (paginationChange)="renderPage()"></data-table>
  </div>
</div>
